"use client";

// src/isRestoring.ts
import * as React from "react";
var IsRestoringContext = /*#__PURE__*/React.createContext(false);
var useIsRestoring = () => React.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;
export { IsRestoringProvider, useIsRestoring };